import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import PersonOutline from "@mui/icons-material/PersonOutline";
import { Link, useNavigate } from "react-router-dom";
import { useUserContext } from "../../../context/MemorialContext";
import "./AvatarCompoenent.css";
import "../notifications/PendingTributesBanner.css";
import { BsChatLeftHeart } from "react-icons/bs";
import { auth } from "../../../utils/firebaseConfig";
import {
  fetchPendingTributesSummary,
  getPendingTributesReviewUrl,
} from "../../../utils/pendingTributes";

function PendingTributesMenuSection({ items, totalCount, onNavigate }) {
  if (!totalCount) return null;

  return (
    <div className="avatar-pending-section">
      <p className="avatar-pending-heading">
        <BsChatLeftHeart />
        Pending tributes
        <span className="avatar-pending-badge">{totalCount}</span>
      </p>
      {items.slice(0, 3).map((item) => (
        <Link
          key={item.memorialId}
          className="avatar-pending-item"
          to={getPendingTributesReviewUrl(item.memorialId, item.slug)}
          onClick={onNavigate}
        >
          <p className="avatar-pending-item-name">{item.memorialName}</p>
          <p className="avatar-pending-item-meta">
            {item.count} pending · Review now
          </p>
        </Link>
      ))}
      {items.length > 1 && (
        <Link className="avatar-pending-view-all" to="/mymemo" onClick={onNavigate}>
          View all memorials
        </Link>
      )}
    </div>
  );
}

export default function AvatarComponent() {
  const { user, signOut } = useUserContext();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [pendingData, setPendingData] = React.useState({ items: [], totalCount: 0 });
  const open = Boolean(anchorEl);

  const loadPending = React.useCallback(async () => {
    if (!auth.currentUser) return;
    const data = await fetchPendingTributesSummary();
    setPendingData(data);
  }, []);

  React.useEffect(() => {
    if (user) loadPending();
  }, [user, loadPending]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    loadPending();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    const success = await signOut();
    if (success) {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("formData");
      window.location.href = "/login";
    }
  };

  const { meta } = user || {};
  const menuContent = (
    <>
      {pendingData.totalCount > 0 && (
        <>
          <PendingTributesMenuSection
            items={pendingData.items}
            totalCount={pendingData.totalCount}
            onNavigate={handleClose}
          />
          <Divider />
        </>
      )}
      <MenuItem onClick={handleClose}>
        <Link
          to="/myaccount"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 12,
            width: "100%",
            color: "inherit",
            textDecoration: "none",
          }}
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <PersonOutline fontSize="small" />
          </ListItemIcon>
          My account
        </Link>
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        Logout
      </MenuItem>
    </>
  );

  return (
    <>
      <div className="mobile" sx={{ BorderTop: "1px solid #333" }}>
        {pendingData.totalCount > 0 && (
          <PendingTributesMenuSection
            items={pendingData.items}
            totalCount={pendingData.totalCount}
            onNavigate={() => {}}
          />
        )}
        <div className="accountIten" onClick={() => navigate("/myaccount")}>
          <Avatar src={meta?.displayPicture} /> My account
        </div>
        <div className="accountIten" onClick={handleLogout}>
          <ListItemIcon className="accountItemIcon">
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </div>
      </div>
      <div className="desktop">
        <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
          <Tooltip title="Account settings">
            <div
              onClick={handleClick}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: 2,
                cursor: "pointer",
                position: "relative",
              }}
            >
              <Avatar src={meta?.displayPicture} sx={{ width: 40, height: 40 }} />
              {pendingData.totalCount > 0 && (
                <span className="avatar-notification-dot">{pendingData.totalCount}</span>
              )}
            </div>
          </Tooltip>
        </Box>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              minWidth: 280,
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          {menuContent}
        </Menu>
      </div>
    </>
  );
}
